// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7a876c9d","952":"943f850e"}[chunkId] + ".chunk.js";
};